// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collections .title{margin-bottom:12px}.collections p{margin:0px}@media (max-width: 969px){.collections{box-sizing:border-box;padding:20px 20px 0px 20px}}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
